import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { ReactComponent as AdaptLogo } from 'Assets/svg/adapt-logo.svg';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon-new.svg';
import { ReactComponent as FieldMappingIcon } from 'Assets/svg/field-mapping.svg';
import enrichmentState from 'Stores/enrichment';
import { HocPopupComponent } from 'Components/common/hocPopupComponent';
import Button from 'Components/common/Button';
import { Utils } from 'Utils/utils';
import { MX_ENRICHMENT_EVENTS } from 'Utils/constants';
import Select from 'Components/common/select';

const CSVFieldMappingPopup = observer(props => {
  const { togglePopup, pagination } = props;
  const [showError, setShowError] = useState(false);
  const wrapperRef = useRef();

  const handleClickEnrich = async () => {
    let isValid = false;
    const fieldsMapped = enrichmentState.fileEnrichmentFieldMapping.reduce(
      (mappedFields, mapping) => {
        if (mapping.csvLabel && mapping.adaptKey)
          return [...mappedFields, mapping.adaptKey];
        return mappedFields;
      },
      [],
    );
    if (
      (fieldsMapped.includes('firstName') &&
        fieldsMapped.includes('lastName') &&
        fieldsMapped.includes('domain')) ||
      fieldsMapped.includes('linkedInURL') ||
      fieldsMapped.includes('email')
    )
      isValid = true;
    else setShowError(true);
    if (isValid) {
      await enrichmentState.updateFileEnrichmentMapping({ pagination });
      togglePopup();
      enrichmentState.showFileEnrichmentInitiatedPopup = true;
    }
  };

  useEffect(() => {
    Utils.mixpanelTrack(MX_ENRICHMENT_EVENTS.CSV_FIELD_MAPPING_SHOWN);
  }, []);

  const CSVHeaderLabels = enrichmentState.fileEnrichmentCSVFields
    .filter(
      item =>
        !enrichmentState.fileEnrichmentFieldMapping.some(
          prop => prop.csvLabel === item,
        ),
    )
    .map(prop => {
      return { label: prop, value: prop };
    });

  if (CSVHeaderLabels.length === 0)
    CSVHeaderLabels.push({
      label: 'No data',
      value: 'No data',
      disabled: true,
    });

  return (
    <HocPopupComponent
      showCloseIcon
      allowMaskClick={false}
      customClassName="csv-field-mapping"
      closeClick={togglePopup}
      wrapperRef={wrapperRef}
    >
      <div className="field-mapping-header">
        <div className="icon-wrap">
          <FieldMappingIcon />
        </div>
        <div className="top-wrapper">
          <div className="popup-title">CSV Field Mapping</div>
          <div className="description">
            Map the columns in your CSV to Adapt field.
          </div>
        </div>
      </div>
      <div className="field-mapping-body">
        <div className="table-header">
          <div className="adapt-field">
            <AdaptLogo className="logo" />
            <span>Adapt</span>
          </div>
          <div className="csv-header">CSV Header</div>
          <div className="sample-data-title">Sample Field Data</div>
        </div>
        <div className="table-body">
          {enrichmentState.fileEnrichmentFieldMapping.map(data => {
            const { adaptKey, csvLabel, adaptLabel } = data;
            return (
              <div className="field" key={adaptKey}>
                <div className="adapt-field">
                  <div>
                    <TickIcon
                      className={`tick-icon${csvLabel ? '' : ' not-selected'}`}
                    />
                    {adaptLabel}
                  </div>
                  <span className="hyphen" />
                </div>
                <div className={`csv-header${csvLabel ? '' : ' no-data'}`}>
                  <Select
                    enableValuesOutsideOfOptions
                    canClearValue
                    searchInputProps={{ placeholder: 'Search Field' }}
                    value={csvLabel ? [csvLabel] : []}
                    dropdownOffset={
                      wrapperRef.current
                        ? {
                            top: wrapperRef.current?.getBoundingClientRect()
                              ?.top,
                            bottom:
                              window.innerHeight -
                              wrapperRef.current?.getBoundingClientRect()
                                ?.bottom,
                          }
                        : { top: 0, bottom: 0 }
                    }
                    showPlaceholderInOptions={false}
                    placeholder="Not mapped yet"
                    getValue={value => {
                      if (
                        [
                          'domain',
                          'email',
                          'linkedin',
                          'firstName',
                          'lastName',
                        ].includes(adaptKey)
                      )
                        setShowError(false);
                      const selectedVal = value?.[0];
                      enrichmentState.setFileEnrichmentFieldMapping(
                        enrichmentState.fileEnrichmentFieldMapping.map(prop => {
                          if (adaptKey === prop.adaptKey)
                            return {
                              ...prop,
                              csvLabel: selectedVal,
                              sampleData:
                                enrichmentState.fileEnrichmentSampleData[
                                  selectedVal
                                ],
                            };
                          return prop;
                        }),
                      );
                    }}
                    options={CSVHeaderLabels}
                  />
                  <span className="hyphen" />
                </div>
                <div className="sample-data" title={data.sampleData}>
                  {data.sampleData}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div
        className={`csv-field-mapping-footer${showError ? ' error-shown' : ''}`}
      >
        {showError && (
          <div className="error">
            <sup>*</sup>Kindly map any one of these fields - Email or Linkedin
            URL or First name, Last name & Company
          </div>
        )}
        <Button btnText="Cancel" className="cancel" click={togglePopup} />
        <Button
          btnText="Enrich"
          loader={enrichmentState.fileEnrichmentLoader}
          className="enrich-now"
          click={handleClickEnrich}
        />
      </div>
    </HocPopupComponent>
  );
});

export default CSVFieldMappingPopup;
